import React from 'react';
import Styling from 'components/AuthStyling';
import Button from 'components/Button';
const PwdCreateSuccess = () => {
  return (
    <>
      <Styling message="Password created successfully.">
        <Button type="submit" text={'Go to login'} />
      </Styling>
    </>
  );
};

export default PwdCreateSuccess;
